import { Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateTemplate = generateAPI<
  {
    body: {
      template: string;
    };
  },
  Wedding
>("put", "wedding/template", "wedding/");
